// Utilitários de texto do lean.
// - `stripMd`: re-export da SSOT partilhada (a diretiva "Hexis sem markdown" é
//   cross-app; a HQ usa o mesmo). Os imports `@/lib/text` continuam a funcionar.
// - `initials`: consolidação das 8 cópias que estavam espalhadas por 7 ecrãs do
//   lean. Fica AQUI (util do lean) e não no packages/shared porque só o lean o usa.
export { stripMd } from '@marcianus/shared/text';

/** Iniciais de um nome: "Israel Nzambi" → "IN" (no máx. 2 letras). */
export function initials(name?: string | null): string {
  return (name || '?').split(' ').filter(Boolean).slice(0, 2).map((w) => w[0]!.toUpperCase()).join('');
}
